import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import './Auth.css';
import PublicPageBackground from '../../components/PublicPageBackground';

const VerifyEmail: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('Invalid or missing verification token');
        setLoading(false);
        return;
      }

      try {
        const response = await api.post('/auth/verify-email', { token });
        const { user, token: authToken } = response.data;

        // Store auth data
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', authToken);

        // Update API default headers with the new token
        api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;

        // Dispatch login event to notify App component
        window.dispatchEvent(new CustomEvent('userLogin'));

        // Dispatch refresh feed event
        window.dispatchEvent(new CustomEvent('refreshFeed'));

        setSuccess(true);
        setLoading(false);

        // Redirect to feed after 2 seconds
        setTimeout(() => {
          navigate('/feed');
        }, 2000);
      } catch (err: any) {
        setLoading(false);
        if (err.response?.status === 400) {
          setError(err.response.data.error || 'Invalid or expired verification token');
        } else {
          setError('Failed to verify email. Please try again.');
        }
      }
    };

    verifyEmail();
  }, [token, navigate]);

  if (loading) {
    return (
      <PublicPageBackground>
        <div className="auth-container">
          <div className="auth-card">
            <h1>Verifying Your Email...</h1>
            <p className="auth-subtitle">Please wait while we verify your email address.</p>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <div className="spinner"></div>
            </div>
          </div>
        </div>
      </PublicPageBackground>
    );
  }

  if (success) {
    return (
      <PublicPageBackground>
        <div className="auth-container">
          <div className="auth-card">
            <h1>Email Verified!</h1>
            <p className="auth-subtitle">Your email has been successfully verified</p>
            
            <div className="success-message" style={{ marginTop: '20px' }}>
              You're all set! Redirecting you to Mindcast...
            </div>
          </div>
        </div>
      </PublicPageBackground>
    );
  }

  return (
    <PublicPageBackground>
      <div className="auth-container">
        <div className="auth-card">
          <h1>Verification Failed</h1>
          <p className="auth-subtitle">We couldn't verify your email</p>
          
          <div className="error-message" style={{ marginTop: '20px' }}>
            {error || 'The verification link is invalid or has expired.'}
          </div>

          <div className="auth-actions" style={{ marginTop: '30px' }}>
            <Link to="/login" className="auth-button">
              Sign In
            </Link>
            <Link to="/register" className="auth-button secondary">
              Register Again
            </Link>
          </div>
        </div>
      </div>
    </PublicPageBackground>
  );
};

export default VerifyEmail;

